// Domaines Officiels LinkerVTC
export const OFFICIAL_WEBSITE_URL = 'https://linkervtc.com';
export const ADMIN_PANEL_URL = 'https://admin.linkervtc.com';
export const PROD_API_URL = 'https://api.linkervtc.com';

export const API_BASE_URL = process.env.REACT_APP_API_URL || (
    process.env.NODE_ENV === 'production' ? 'https://api.linkervtc.com' : 'http://localhost:3000'
);

// Récupération dynamique de la clé Google Maps depuis le backend
export const fetchMapsApiKey = async () => {
    try {
        const res = await fetch(`${API_BASE_URL}/settings/maps-key`);
        const data = await res.json();
        if (data.success && data.mapsApiKey) {
            return data.mapsApiKey;
        }
    } catch (e) {
        console.warn('Impossible de récupérer la clé maps dynamique:', e);
    }
    return process.env.REACT_APP_GOOGLE_MAPS_KEY || 'AIzaSyDnDFcEd8Z49W8O7H8eNFNQ2-4fK79LMiA';
};
